import { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./components/halo/Home";
import Error404 from "./pages/Error404";

import RootContainer from "./pages/RootContainer";

const InBodyPhoneNumberContainer = lazy(() =>
  import("./components/InBodyPhoneNumberContainer")
);
const InBodyVerifySMSContainer = lazy(() =>
  import("./components/InBodyVerifySMSContainer")
);

const __children__ = [];
if (process.env.NODE_ENV === "development") {
  __children__.push({
    path: "/connect",
    element: <HomePage />,
  });
  __children__.push({
    path: "/connect/inbody/show",
    element: <HomePage status="connected" />,
  });
}
const router = createBrowserRouter([
  {
    path: "/",
    element: <Error404 />,
    errorElement: <Error404 />,
  },
  {
    path: "/",
    element: <RootContainer />,
    errorElement: <Error404 />,
    children: [
      ...__children__,
      {
        path: "/connect/inbody/verify",
        element: (
          <Suspense fallback={<p>Loading...</p>}>
            <InBodyVerifySMSContainer />
          </Suspense>
        ),
      },
      {
        path: "/connect/inbody",
        element: (
          <Suspense fallback={<p>Loading...</p>}>
            <InBodyPhoneNumberContainer />
          </Suspense>
        ),
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
